export default "__VITE_ASSET__46edfc92__"